(function () {
  'use strict';
  function init(root) {
    var templates = root.querySelectorAll('template[data-ws-deferred-image]');
    function reveal(template) {
      if (!template.parentNode) return;
      var fragment = template.content.cloneNode(true);
      var images = fragment.querySelectorAll('img');
      for (var i = 0; i < images.length; i++) {
        images[i].setAttribute('decoding', 'async');
      }
      template.parentNode.replaceChild(fragment, template);
    }
    if (!('IntersectionObserver' in window)) {
      for (var i = 0; i < templates.length; i++) reveal(templates[i]);
      return;
    }
    for (var i = 0; i < templates.length; i++) {
      (function (template) {
        var container = template.parentElement;
        var observer = new IntersectionObserver(function (entries) {
          if (entries.some(function (entry) { return entry.isIntersecting; })) {
            observer.disconnect();
            reveal(template);
          }
        }, { rootMargin: '400px 0px' });
        observer.observe(container);
      })(templates[i]);
    }
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { init(document); });
  } else {
    init(document);
  }
  document.addEventListener('shopify:section:load', function (event) { init(event.target); });
})();
